<template>
  <v-sheet>
    <div>
      <h2
        v-if="isMember()"
        class="courses-link"
        @click="$router.push(`/courses`)"
      >
        All Learning Resources
      </h2>
      <h2
        v-else-if="userMode == 'MENTOR'"
        class="courses-link"
        @click="$router.push(`/mentor/courses/user/${menteeUserId}`)"
      >
        All Learning Resources
      </h2>
      <h2 v-else class="courses-link" @click="$router.push(`/manager/courses`)">
        All Learning Resources
      </h2>
    </div>
    <base-badge
      :imageUrl="badgeUrl"
      class="center-align"
      style="padding-top: 10px;"
    ></base-badge>
    <h1 id="js-course-name" class="center-align course-name">{{ name }}</h1>
    <div id="js-course-description" class="center-align course-description">
      {{ description }}
    </div>
    <learning-items-grid-member :course-id="parseInt(courseId)">
    </learning-items-grid-member>
    <nudges-list
      class="my-4"
      v-if="userMode == 'MENTOR'"
      :nudges="nudges"
      :menteeId="menteeUserId"
      :mentorId="loggedInUserId"
      nudgeableType="Course"
      :nudgeableId="parseInt(this.courseId)"
      :text="nudgeText"
      v-on:nudge="refreshNudges"
    ></nudges-list>
  </v-sheet>
</template>

<script>
import EventBus from "@/lib/eventBus"
import LearningItemsGridMember from "@/containers/learnings/LearningItemsGridMember"
import BaseBadge from "@/components/BaseBadge"
import NudgesList from "@/components/NudgesList"
import userMixin from "@/mixins/userMixin"

export default {
  mixins: [userMixin],
  components: {
    BaseBadge,
    NudgesList,
    LearningItemsGridMember
  },
  data: function() {
    return {
      courseId: this.$route.params.id,
      panel: [],
      addingNudge: false
    }
  },
  computed: {
    name() {
      let course = this.$store.getters["courses/getCourseById"](this.courseId)
      return course ? course.name : ""
    },
    description() {
      let course = this.$store.getters["courses/getCourseById"](this.courseId)
      return course ? course.description : ""
    },
    badgeUrl() {
      let course = this.$store.getters["courses/getCourseById"](this.courseId)
      return course ? course.badge_url : ""
    },
    learningItems() {
      let course = this.$store.getters["courses/getCourseById"](this.courseId)
      return course ? course.learning_items : []
    },
    userMode() {
      return this.$store.getters["globals/getUserMode"]
    },
    menteeUserId() {
      return this.$store.getters["globals/getMenteeId"]
    },
    nudges() {
      return this.$store.getters["nudges/getNudgesByNudgeable"](
        "Course",
        this.courseId
      )
    },
    loggedInUserId() {
      let user = this.$store.getters["users/getMe"]
      return user ? user.id : 0
    },
    nudgeText() {
      const course = this.$store.getters["courses/getCourseById"](this.courseId)
      let s = "Please have a look at the Learning Resource "
      if (course) {
        s = s + "titled '" + course.name + "' "
      }
      s =
        s + "located at " + window.location.origin + "/#" + this.$route.fullPath
      return s
    }
  },
  created() {
    this.$store.dispatch("courses/loadCourse", {
      id: this.courseId
    })

    if (this.menteeUserId & (this.menteeUserId > 0)) {
      this.$store.dispatch("nudges/loadNudgesByMentee", this.menteeUserId)
    }

    EventBus.$emit("title", this.title)
  },
  methods: {
    completedClass(status) {
      let s = ""
      if (status) {
        s = "completed-item"
      }
      return s
    },
    refreshNudges() {
      this.$store.dispatch("nudges/loadNudgesByMentee", this.menteeUserId)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../scss/variables";
@import "../../scss/buttons";

.completed-item {
  text-decoration: line-through;
}
.course-name {
  color: $orange;
}
.course-description {
  font-style: italic;
  font-size: 1.4em;
  color: $light-grey;
}
.center-align {
  display: flex;
  justify-content: center;
}

.courses-link {
  cursor: pointer;
  font-weight: 300;
  font-style: italic;
  color: $light-yellow;
}

.courses-link:hover {
  color: $dark-blue;
}

h2 {
  @media only screen and (max-width: 450px) {
    font-size: 1em;
  }
}
</style>
